module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pa-0": ""
    }
  }, [_c('V-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mb-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v("Financial Forecasts & Token Economics")]), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("Unaudited Projections Based on Company's Latest Financial Models")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('v-container', {
    attrs: {
      "pa-0": "",
      "grid-list-xl": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2018-21 IOB QUALIFIED RESERVE")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/qr.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2018-21 IOB REVENUE PROJECTION")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/pr.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2018-21 IOB NET REVENUE & NET INCOME")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/nr.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2017-21 IOB TOKEN SOLD")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/ts.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("IOB TOTAL TOKENS")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/tt.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-16 primary--text"
  }, [_vm._v("2018-19 FUNDING")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-img', {
    attrs: {
      "src": "https://images.iob.community/SIP/material/website/ir/funding.png",
      "contain": "",
      "height": "400px"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v(" IOB Token Address & Code")]), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("Please double check the token address on your wallet")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3"
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("ERC20 CONTRACT ADDRESS")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("0x6130ff302f24267380753e52ECe48B852be3Dd38")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("ETHERSCAN CONTRACT ADDRESS")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": "https://etherscan.io/address/0x6130ff302f24267380753e52ece48b852be3dd38#"
    }
  }, [_vm._v("https://etherscan.io/address/0x6130ff302f24267380753e52ece48b852be3dd38")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("GITHUB CONTRACT REPOSITORIES")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": "https://github.com/IOBteam?tab=repositories"
    }
  }, [_vm._v("https://github.com/IOBteam?tab=repositories")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-lg-right",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": "",
      "mt-5": ""
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": _vm.domainName
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "20"
    }
  }, [_vm._v("arrow_back")])], 1)])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d71c3a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/Investorrelations.vue
// module id = 470
// module chunks = 0